import MessagingCard from "~/componentsDS/LPComponents/components/MessagingCard";
import LabReviewCard from "~/componentsDS/LPComponents/components/LabReviewCard";
import MonitoringCard from "~/componentsDS/LPComponents/components/MonitoringCard";

export const notAloneData = [
    {
        id: "messaging",
        component: <MessagingCard alt="Unlimited secure messaging with Inner Balance clinician for ongoing hormone support" />,
        title: "Unlimited secured messaging"
    },
    {
        id: "lab-review",
        component: <LabReviewCard alt="Your personalized hormone action plan icon — Inner Balance Oestra treatment steps" />,
        title:"Lab review and dose adjustments if needed"
    },
    {
        id: "monitoring",
        component: <MonitoringCard alt="Ongoing hormone monitoring with Inner Balance clinician" />,
        title: "Ongoing monitoring — not one-time prescribing."
    },
]

export { DEFAULT_HERO_FEATURES as heroFeaturesData } from "~/componentsDS/LPComponents/data";
